<template>
  <div class="app-container" :class="{ 'app-container-fluid': fluid }">
    <slot />
  </div>
</template>

<script lang="ts">
import { Component, Prop } from "vue-property-decorator";
import { BaseComponent } from "../base-component/base-component";

@Component({
  name: "app-container",
})
export default class AppContainer extends BaseComponent {
  @Prop({ default: false }) fluid!: boolean;
}
</script>

<style lang="scss">
.app-container, .app-container-fluid, .app-container-xl, .app-container-lg, .app-container-md, .app-container-sm {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .app-container-sm, .app-container:not(.app-container-fluid) {
    max-width: 540px;
  }
}
@media (min-width: 768px) {
  .app-container-md, .app-container-sm, .app-container:not(.app-container-fluid) {
    max-width: 720px;
  }
}
@media (min-width: 992px) {
  .app-container-lg, .app-container-md, .app-container-sm, .app-container:not(.app-container-fluid) {
    max-width: 960px;
  }
}
@media (min-width: 1200px) {
  .app-container-xl, .app-container-lg, .app-container-md, .app-container-sm, .app-container:not(.app-container-fluid) {
    max-width: 1140px;
  }
}
@media (min-width: 1400px) {
  .app-container-xl, .app-container-lg, .app-container-md, .app-container-sm, .app-container:not(.app-container-fluid) {
    max-width: 1380px;
  }
}
</style>
